import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';

import { Checkbox } from '@process-advisor/process-miner/components/shared/checkbox';
import { type ZoomToFitProps } from '@process-advisor/process-miner/api/methods/settings/changeZoomToFit';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
`;

export const ZoomToFit = () => {
    const [ZoomToFit, setZoomToFit] = React.useState<ZoomToFitProps>({});
    const onChange = _.curry((
        key: keyof ZoomToFitProps,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newZoomToFit = { ...ZoomToFit, [key]: e.target.checked };
        setZoomToFit(newZoomToFit);
        apiProvider.changeZoomToFit(newZoomToFit);
        apiProvider.rebuildPVDiagram({});
    });

    React.useEffect(() => {
        setZoomToFit(apiProvider.getZoomToFit());
    }, []);

    React.useEffect(() => {
        const listener = () =>
            setZoomToFit(apiProvider.getZoomToFit());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Wrapper>
            <Checkbox
                label=''
                checked={!!ZoomToFit.visible}
                handleOnChange={onChange('visible')} />
        </Wrapper>
    );
};
